import { render, staticRenderFns } from "./folders-charterers-aditionaly-wrap.vue?vue&type=template&id=0348e6d6&scoped=true"
import script from "./folders-charterers-aditionaly-wrap.vue?vue&type=script&lang=js"
export * from "./folders-charterers-aditionaly-wrap.vue?vue&type=script&lang=js"
import style0 from "./folders-charterers-aditionaly-wrap.vue?vue&type=style&index=0&id=0348e6d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0348e6d6",
  null
  
)

export default component.exports